import { render, staticRenderFns } from "./VoucherUsageDetail.vue?vue&type=template&id=58f08332&scoped=true"
import script from "./VoucherUsageDetail.vue?vue&type=script&lang=js"
export * from "./VoucherUsageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f08332",
  null
  
)

export default component.exports